<template>
  <div class="indicator">
    <div ref="holder" v-if="result === ''">&nbsp;</div>
    <div class="indicator error" v-if="result === 'failed'">
      <span class="glyphicon glyphicon-remove-sign"></span>
    </div>
    <div class="indicator warning" v-if="result === 'warning'">
      <span class="glyphicon glyphicon-exclamation-sign"></span>
    </div>
    <div class="indicator passed" v-if="result === 'passed'">
      <span class="glyphicon glyphicon-ok-sign"></span>
    </div>
  </div>
</template>

<script>
import Spinner from 'spin.js'

export default{
  name: 'check-status',
  props: ['result'],
  mounted () {
    // Start the spinner
    var spinner = new Spinner({
      color: '#333',
      width: 2,
      length: 0,
      radius: 5,
      top: '60%',
      left: '82%'
    }).spin()

    if (this.$refs.holder) {
      this.$refs.holder.appendChild(spinner.el)
    }

    this.$watch('result', (newVal) => {
      if (newVal && spinner) {
        spinner.stop()
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// CheckerStatus.vue?762645d4